import { Component } from '@angular/core';

@Component({
  selector: 'app-course-rules',
  standalone: false,
  templateUrl: './course-rules.html',
  styleUrl: './course-rules.scss',
})
export class CourseRules {}
